<template>
  <el-dialog
    :visible.sync="selfVisible"
    title="同步组织选择"
    class="app-container"
    v-loading="selfLoading"
    element-loading-text="加载中"
    element-loading-background="rgba(0, 0, 0, 0.1)"
  >
    <div style="text-align: center">
      <el-transfer
        filterable
        style="text-align: left; display: inline-block"
        :filter-method="filterMethod"
        filter-placeholder="请输入名称"
        :titles="['组织列表', '已选择']"
        v-model="targetData"
        :props="{key: 'id',label: 'name'}"
        :data="transferdata"
      ></el-transfer>
    </div>
    <span slot="footer">
      <el-button type="info" icon="el-icon-close" @click="close">取消</el-button>
      <el-button type="primary" icon="el-icon-check" @click="save">同步数据</el-button>
    </span>
    <step ref="orderCreateStep"></step>
  </el-dialog>
</template>

<script>
import axios from "axios";
import config from "@/common/config.js";
import AjaxHelper from "@/common/js/AjaxHelper";
import step from "./orderCreateStep";
export default {
  components: {
    step
  },
  data() {
    return {
      targetData: [],
      selfVisible: false,
      selfLoading: false,
      transferdata: [],
      searchData: {},
      voucherQueryModel: {},
      saveApi: config.BASE_Middle_API + "OrderCreate/CloudOrderHandle"
    };
  },
  methods: {
    filterMethod(query, item) {
      return item.name.indexOf(query) > -1;
    },
    createDialog(visible, data, voucherQueryModel, searchData) {
      this.selfVisible = visible;
      this.transferdata = data;
      this.voucherQueryModel = voucherQueryModel;
      this.searchData = searchData;
    },
    save() {
      const _this = this;
      const confirmData = {
        brandID: _this.voucherQueryModel.brandId,
        billNo: _this.searchData.billNo,
        otherSideName: _this.searchData.otherSideName,
        otherWarehouseName: _this.searchData.otherWarehouseName,
        billBusTypes: _this.searchData.billBusTypes,
        billTypes: _this.searchData.billTypes,
        totalIncloudTaxMoneyMin: _this.searchData.totalIncloudTaxMoneyMin,
        totalIncloudTaxMoneyMax: _this.searchData.totalIncloudTaxMoneyMax,
        startTime: _this.searchData.startTime,
        endTime: _this.searchData.endTime,
        storeIDs: _this.targetData,
        groupType: _this.voucherQueryModel.groupType,
        orderIds: _this.voucherQueryModel.orderIds,
        orderState: _this.searchData.orderState,
        makeOrderState: _this.searchData.makeOrderState
      };
      _this.$refs.orderCreateStep.beginStep(
        _this.voucherQueryModel.vouchernumber
      );

      AjaxHelper.post(
        config.BASE_Middle_API + "OrderCreate/CheckErrorBasicDatas",
        confirmData
      )
        .then(function(response) {
          if (response.result.length > 0) {
            _this.$refs.orderCreateStep.failstep1(response.result);
          } else {
            var totalCount = 0;
            if (_this.voucherQueryModel.orderIds.length == 0) {
              totalCount = _this.voucherQueryModel.vouchernumber;
            } else {
              totalCount = _this.voucherQueryModel.orderIds.length;
            }
            _this.$refs.orderCreateStep.successstep1(totalCount);
            AjaxHelper.post(_this.saveApi, confirmData)
              .then(function(response) {
                if (response.result.isSuccess) {
                  _this.$refs.orderCreateStep.successstep2();
                } else {
                  _this.$refs.orderCreateStep.failstep2(
                    response.result.errorMsg
                  );
                }
              })
              .catch(function(error) {
                _this.$refs.orderCreateStep.failstep2(error.message);
              });
          }
        })
        .catch(function(error) {});
    },
    close() {
      this.selfVisible = false;
    }
  }
};
</script>
<style>
.el-transfer-panel {
  width: 254px;
}
</style>